import { useState, useEffect, useCallback } from 'react';

/**
 * Hook para gerenciar a autenticação do administrador
 * 
 * @returns {Object} Objeto contendo o estado de autenticação e métodos
 */
export const useAdminAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  /**
   * Verifica se o administrador está autenticado
   * @returns {boolean} Estado de autenticação
   */
  const checkAuth = useCallback(() => {
    try {
      // Recupera os dados de autenticação do localStorage
      const authData = JSON.parse(localStorage.getItem('lunaAdmin'));
      
      // Verifica se existe um token
      if (!authData || !authData.token) {
        setIsAuthenticated(false);
        return false;
      }
      
      // Verifica se o token expirou
      const now = Date.now();
      if (authData.expiresAt && authData.expiresAt < now) {
        // Token expirado, remover do localStorage
        localStorage.removeItem('lunaAdmin');
        setIsAuthenticated(false);
        return false;
      }
      
      // Usuário está autenticado
      setIsAuthenticated(true);
      return true;
    } catch (error) {
      console.error('Erro ao verificar autenticação:', error);
      setIsAuthenticated(false);
      return false;
    }
  }, []);
  
  /**
   * Encerra a sessão do administrador
   */
  const logout = useCallback(() => {
    // Remove os dados de autenticação do localStorage
    localStorage.removeItem('lunaAdmin');
    setIsAuthenticated(false);
  }, []);
  
  // Verifica a autenticação ao carregar o componente
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);
  
  return {
    isAuthenticated,
    checkAuth,
    logout
  };
};

export default useAdminAuth; 